import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { LanguageProvider } from './lib/Language.jsx';
import './styles.css';
createRoot(document.getElementById('root')).render(<LanguageProvider><App /></LanguageProvider>);
